import Vue from "vue";
import Vuex from "vuex";
import User from '@/services/Users'
Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        
    },
    state: {
        Auth: false,
        tk: null,
        weath: []
    },
    mutations: {
        dkhlat (state){
            state.Auth = true
        },
        khrjat (state){
            state.Auth =  false
        },
        checktoken(state){
            User.checktoken(state.tk)
            .then(() => {
              console.log('tesss')
              return true
            })
            .catch((err) => {
              console.log('err')
              return false
            })
        }
    },
    actions: {

    }
})